var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"copyright"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" © 7GAMES. All rights reserved. ")]),_c('nav',[_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")]),_c('router-link',{attrs:{"to":"/terms-of-service"}},[_vm._v("Terms of Service")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }